// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import RotateRightOutlinedSvg from "@ant-design/icons-svg/lib/asn/RotateRightOutlined";
import AntdIcon from "../components/AntdIcon";
const RotateRightOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: RotateRightOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    RotateRightOutlined.displayName = "RotateRightOutlined";
}
export default /*#__PURE__*/ React.forwardRef(RotateRightOutlined);
